module.exports = __webpack_public_path__ + "img/1.53918511.jpg";